module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/vi/1-924dff600e823e5a1356808d0daf1a06.jpg";